export default "__VITE_ASSET__iWrcJDrc__"